<ng-container *ngIf="loading(); then openLoading; else closeloadingTemplate"></ng-container>
<ng-template #openLoading>
  <ng-container *ngIf="electronicChannel() === 1; then insureLoaddingStyle; else otherLoadingStyle"></ng-container>
  <ng-template #insureLoaddingStyle>
    <div>
      <h3><b>ยินดีต้อนรับเข้าสู่<br>บริการหาหมอออนไลน์</b></h3>
      <span class="uk-padding" uk-spinner="ratio: 4.5"></span>
      <div class="uk-text-center uk-text-primary">
        <h5 style="margin: 0 !important;">กรุณารอสักครู่</h5>
      </div>
    </div>
  </ng-template>
  <ng-template #otherLoadingStyle>
    <div class="uk-card uk uk-card-body">
      <div class="loader">Loading...</div>
    </div>
  </ng-template>
</ng-template>
<ng-template #closeloadingTemplate>
  <ng-container *ngIf="isOpenConfirmUpdateLine(); then openConfirmUpdateLine; else closeConfirmUpdateLine"></ng-container>
  <ng-template #openConfirmUpdateLine>

    <div class="uk-flex uk-flex-middle uk-flex-column ">

      <label class="uk-form-label uk-text-large">หมายเลขบัตรประชาชนนี้ท่านเคยลงทะเบียนไว้กับเครื่องอื่นแล้ว
        หากท่านประสงค์จะเปลี่ยนแปลงเครื่องที่ลงทะเบียนกรุณากดยืนยันการเปลี่ยนแปลงข้อมูล</label>
      <div class="uk-padding-small"></div>
      <div class="uk-text-left uk-padding-small" style="background-color: #f8f8f8;">
        <small>หมายเหตุ : หลังจากท่านกดยืนยันการเปลี่ยนแปลงเครื่องแล้ว ท่านจะไม่สามารถใช้บริการที่เครื่องเก่าได้</small>
      </div>

      <div class="uk-margin-top">
        <button type="submit"
          class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
          (click)="onClickConfirme()">ยืนยัน
        </button>
        <div class="uk-margin-top">
          <button type="submit"
            class="uk-button uk-button-second uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            (click)="redirectToChateRoom()">ยกเลิก
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #closeConfirmUpdateLine>
    <ng-container *ngIf="isOpenPrefill(); then openPrefill; else closePrefill"></ng-container>
    <ng-template #openPrefill>
      <h3><b>ยินดีต้อนรับเข้าสู่<br>บริการหาหมอออนไลน์</b></h3>
      <form autocomplete="off" #registerForm="ngForm" class="uk-margin-small-bottom uk-text-left">
        <div class="uk-text-left">
          <h5 style="margin-bottom: 0.3rem;">ตรวจสอบข้อมูลของท่าน เพื่อยืนยันตัวตน</h5>
        </div>
        <div class="uk-background-cover" style="padding:15px 15px 0px 15px"
          [ngStyle]="{'background-image': 'url('+bg_image+')'}">
          <div>
            <label for="id-card" class="uk-form-label" style="color: white;">เลขที่บัตรประจำตัวประชาชน</label>
            <div class="uk-position-relative">
              <input id="id-card" class="uk-input uk-border-rounded uk-text-bold uk-text-large"
                style="background-color:transparent; border: none;color: white;" type="text"
                placeholder="กรุณาระบุหมายเลขบัตรประชาชน" autocomplete="off" mask="0-00AA-AAAAA-00-0" name="idCard"
                #idCard="ngModel" [(ngModel)]="model().form.idcard.text" disabled />
            </div>
          </div>
          <hr style="margin: 0;margin-bottom: 0.2rem;">
          <div>
            <label for="mobile" class="uk-form-label" style="color: white;">หมายเลขโทรศัพท์มือถือ</label>
            <div class="uk-position-relative">
              <input id="mobile" class="uk-input uk-border-rounded uk-text-bold uk-text-large"
                style="background-color:transparent; border: none;color: white;" type="text"
                placeholder="กรุณาระบุหมายเลขโทรศัพท์มือถือ" mask="00A-AAA-A000" name="mobile" #mobile="ngModel"
                [(ngModel)]="model().form.mobile.text" disabled />
            </div>
          </div>
        </div>
        <div class="uk-padding-small"></div>
        <div class="uk-text-left uk-padding-small" style="background-color: #f8f8f8;" *ngIf="remarkText() != ''">
          <small [innerHTML]="remarkText() | sanitizeHtml"></small>
        </div>
        <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
          <button type="submit"
            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            (click)="onSubmit()">{{btnSubmitText()}}
          </button>
        </div>
      </form>
      <!-- </ng-template> -->
    </ng-template>
    <ng-template #closePrefill>
      <div class="uk-card uk uk-card-body">
        <div class="loader">Loading...</div>
      </div>
    </ng-template>
  </ng-template>
</ng-template>